import { addMethod, number, type NumberSchema } from 'yup';

declare module 'yup' {
  interface NumberSchema<TType, TContext, TDefault, TFlags> {
    emptyAsUndefined(): this;
  }
}
addMethod<NumberSchema>(number, 'emptyAsUndefined', function () {
  return this.transform((value: number, originalValue) => (String(originalValue)?.trim() ? value : undefined));
});
